import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetPlanAvDeviationByClientName = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_PALN_AV_DEVIATION_BY_CLIENT_NAME + id,
    token
  );
  return res;
};

export const UpdatePlanAvDeviation = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_PALN_AV_DEVIATION, payload, token);
  return res;
};

export const CalculateDeviation = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.CALCULATE_PALN_AV_DEVIATION + id,
    "",
    token
  );
  return res;
};

export const CheckClientInCensusDetails = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.CHECK_CLIENT_IN_CENSUS_DETAIL + id, token);
  return res;
};

export const CheckClientInCensusByClientId = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.CHECK_CLIENT_IN_CENSUS_BY_CLIENT + id,
    token
  );
  return res;
};

export const UpdateCensus = async (client_ID, Stage,UserId) => {
  const token = localStorage.getItem("token");
  let url = `${Url.UPDATE_CENSUS + client_ID}&Stage=${Stage}&UserId=${UserId}`;
  let res = await Services.PUT(url, "", token);
  return res;
};

export const UpdateCensusStage2 = async (client_ID, Stage,UserId) => {
  const token = localStorage.getItem("token");
  let url = `${Url.UPDATE_CENSUS_STAGE2 + client_ID}&Stage=${Stage}&UserId=${UserId}`;
  let res = await Services.PUT(url, "", token);
  return res;
};
export const UpdateCensusStage3 = async (client_ID, Stage) => {
  const token = localStorage.getItem("token");
  let url = `${Url.UPDATE_CENSUS_STAGE3 + client_ID}&Stage=${Stage}`;
  let res = await Services.PUT(url, "", token);
  return res;
};

export const UpdateCensusStage4 = async (client_ID, Stage) => {
  const token = localStorage.getItem("token");
  let url = `${Url.UPDATE_CENSUS_STAGE4 + client_ID}&Stage=${Stage}`;
  let res = await Services.PUT(url, "", token);
  return res;
};

export const UpdateCensusStage5 = async (client_ID, Stage) => {
  const token = localStorage.getItem("token");
  let url = `${Url.UPDATE_CENSUS_STAGE5 + client_ID}&Stage=${Stage}`;
  let res = await Services.PUT(url, "", token);
  return res;
};

export const UpdateCensusStage6 = async (client_ID, Stage) => {
  const token = localStorage.getItem("token");
  let url = `${Url.UPDATE_CENSUS_STAGE6 + client_ID}&Stage=${Stage}`;
  let res = await Services.PUT(url, "", token);
  return res;
};

// export const DeletePlanVar = async(id) => {
//   const token = localStorage.getItem("token");

//   return axios.delete(`${config.API_URL}/api/ACGPlanVar/DeletePlanVar/${id}`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     }
//   });
// };
